export const PushActionTypes = {
  INVOICE: 'invoice',
  EXPENSE: 'expense',
  TRANSACTION: 'transaction',
}
